import type { BiaxCartItem, Term } from './types';

export function isArrangementInCart(id: string, cartItems: BiaxCartItem[]): boolean {
    return cartItems.some(({ bannerId }) => bannerId === id);
}

export function hasProperty(obj: unknown, key: string): obj is { [key: string]: unknown } {
    return typeof obj === 'object' && obj !== null && key in obj;
}

export const compareTerms = (termA: Term, termB: Term): number => {
    if (termA.year !== termB.year) {
        return termA.year - termB.year;
    }
    if (termA.semester === termB.semester) {
        return 0;
    }
    return termA.semester === 'Spring' ? -1 : 1;
};
